import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';

import * as classes from '../AttributeManagement/ConfigurationItem.module.css';

const OptimizationReportCustomListItem = ({
    onSave,
    onCancel,
    ...props
}) => {
    let { dataItem, selected, ...others } = props;

    return (
        <li {...others}>
            <div>
                <React.Fragment>
                    <div className={classes.ConfigurationItemContainer}>
                        <div className={classes.checkboxContainer}>
                            {
                                dataItem.available ?
                                    <Checkbox
                                        value="include"
                                        checked={selected}
                                        name="include"
                                        size={'small'}
                                        style={{
                                            color: 'black'
                                        }}
                                    />
                                    : null
                            }
                        </div>
                        <div className={classes.sensorContainer}>
                            {
                                dataItem.isExternal ?
                                    <span className={classes.OptimizationReportText}>
                                        <span>{dataItem.name}</span><br />
                                        <span className={classes.ExternalSensorEntityName}>{`${dataItem.entityName}`}</span>
                                    </span>
                                    :
                                    <span className={classes.OptimizationReportText}>
                                        <span>{dataItem.name}</span><br />
                                        <span className={classes.SensorTypeName}>{`${dataItem.sensorType.name}`}</span>
                                    </span>
                            }
                        </div>
                    </div>
                </React.Fragment>
                
            </div>
        </li>
    );
};

export default OptimizationReportCustomListItem;
